import api from "../../../shared/services/api";

// Camada semântica do BI (/api/bi): catálogo, query e dashboards.
export async function fetchCatalogo() { return (await api.get("/bi/catalogo")).data; }

const cache = new Map(); // chave JSON → promessa (dedupe entre widgets do mesmo dashboard)
export function limparCacheQuery() { cache.clear(); }
export function query(body) {
    const k = JSON.stringify(body);
    if (!cache.has(k)) {
        cache.set(k, api.post("/bi/query", body).then(r => r.data).catch(e => { cache.delete(k); throw e; }));
        if (cache.size > 200) cache.delete(cache.keys().next().value);
    }
    return cache.get(k);
}

// Tela "Por produto": vendas + bumps × gasto das campanhas por conta
export async function fetchProdutoOpcoes() { return (await api.get("/bi/produto/opcoes")).data; }
export async function fetchProdutoRegras(produtoId) { return (await api.get(`/bi/produto/${produtoId}/regras`)).data; }
export async function salvarProdutoRegras(produtoId, body) { return (await api.put(`/bi/produto/${produtoId}/regras`, body)).data; }
export async function salvarProdutoMeta(produtoId, body) { return (await api.put(`/bi/produto/${produtoId}/meta`, body)).data; }
export async function apagarProdutoMeta(produtoId) { return (await api.delete(`/bi/produto/${produtoId}/meta`)).data; }
export async function fetchProdutoResumo(produtoId, start, end) { return (await api.get(`/bi/produto/${produtoId}/resumo`, { params: { start, end } })).data; }

export async function fetchDashboards() { return (await api.get("/bi/dashboards")).data; }
export async function fetchDashboard(id) { return (await api.get(`/bi/dashboards/${encodeURIComponent(id)}`)).data; }
export async function criarDashboard(body) { return (await api.post("/bi/dashboards", body)).data; }
export async function salvarDashboard(id, body) { return (await api.put(`/bi/dashboards/${id}`, body)).data; }
export async function excluirDashboard(id) { return (await api.delete(`/bi/dashboards/${id}`)).data; }
